export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/page-next.4efc68a7-da2407.svg";